import * as R from "ramda";
import { validateObject, validateField } from "util/validation";
import { notBlank } from "../../util/ext";
import { curry } from "ramda";

/**
 * Module descriptions are stored as HTML; this pattern rejects any value that
 * renders as empty or only whitespace.
 * TipTap emits an empty editor as <p></p> (nothing between the tags), and repeated
 * empty paragraphs as <p></p><p></p>.
 * (Legacy react-rte content may still be <p><br></p> or use '&nbsp;'.)
 */
const NOT_EMPTY_HTML_PATTERN = /^(?!\s*(?:<p>\s*(?:&nbsp;|<br\s*\/?>|\s)*\s*<\/p>\s*)+$)[\s\S]*$/;

const descriptionConstraint = {
  presence: {
    allowEmpty: false,
    message: "^Description must not be blank",
  },
  format: {
    pattern: NOT_EMPTY_HTML_PATTERN,
    message: "^Description must not be blank",
  },
};

const moduleConstraints = {
  name: {
    presence: {
      allowEmpty: false,
      message: "^Module title can't be blank",
    },
  },
  description: descriptionConstraint,
  displayName: {
    presence: {
      allowEmpty: false,
      message: "^Module display name can't be blank",
    },
  },
  iconUrl: {
    presence: {
      allowEmpty: false,
      message: "^A thumbnail image is required",
    },
  },
  internalCode: {
    presence: {
      allowEmpty: false,
      message: "^Identifier code is required",
    },
  },
};

const newModuleConstraints = {
  name: {
    presence: {
      allowEmpty: false,
      message: "^Module title can't be blank",
    },
  },
  description: descriptionConstraint,
};

export const validateModuleField = (field, value, errors = {}) =>
  validateField(moduleConstraints, field, value, errors);

export const validateNewModuleField = (field, value, errors = {}) =>
  validateField(newModuleConstraints, field, value, errors);

export const validateModule = R.partial(validateObject, [moduleConstraints]);

export const validateNewModule = R.partial(validateObject, [
  newModuleConstraints,
]);

export const hasError = curry((errors, field) => notBlank(errors[field]));

export const firstError = curry((errors, field) =>
  errors[field] ? errors[field][0] : "",
);
